<div class="pt-4 pl-md-4" *ngIf="serverError !== null">
  <h2>Server Error: {{ serverError }}</h2>
</div>

<div class="pt-4 pl-md-4 mb-5" *ngIf="serverError === null">
  <h2 class="mb-3">
    Membership Cancellation Reason Settings
    <span *ngIf="loadingOrgConfig" class="text-muted"> - Loading...</span>
  </h2>

  <ng-container *ngIf="!loadingOrgConfig">
    <form (submit)="handleSave()" *ngIf="orgConfig">

      <div class="form-group">
        <div class="form-check">
          <input class="form-check-input" type="checkbox"
                 name="require_membership_cancellation_reason" id="require_membership_cancellation_reason"
                 [(ngModel)]="orgConfig.require_membership_cancellation_reason">
          <label class="form-check-label" for="require_membership_cancellation_reason">
            Ask customers why they are cancelling their membership.
          </label>
        </div>
        <small class="form-text text-muted">
          If this option is selected, a reason will be required when cancelling a membership either in the Climber App or in the Staff Site.
        </small>
      </div>

      <div class="form-group" *ngIf="orgConfig.require_membership_cancellation_reason">
        <label for="reasonOptionsInput">
          Cancellation Reasons
        </label>
        <textarea class="form-control"
                  name="reasonOptionsInput" id="reasonOptionsInput"
                  [rows]="reasonOptionsInputNumRows"
                  [(ngModel)]="reasonOptionsInput"></textarea>
        <small class="form-text text-muted">
          Enter each reason option on a separate line.
        </small>
      </div>

      <div class="alert alert-danger" role="alert" *ngIf="errors.non_field_errors">
        {{ errors.non_field_errors }}
      </div>
      <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
        {{ errorMessage }}
      </div>

      <div class="alert alert-info" role="alert" *ngIf="loadingSave">
        Loading...
      </div>

      <div class="alert alert-success" role="alert" *ngIf="successMessage">
        {{ successMessage }}
      </div>

      <!-- Place save button first so that the enter key press activates it -->
      <div class="float-right">
        <button type="submit" class="btn btn-primary"
                [disabled]="loadingSave" [class.disabled]="loadingSave">
          {{ loadingSave ? 'Loading...' : 'Save' }}
        </button>
      </div>
      <a [routerLink]="'/memberships-and-passes'"
         class="btn btn-secondary"
         [class.disabled]="loadingSave">
        Back
      </a>

    </form>
  </ng-container>
</div>
